import { useImperativeHandle } from 'react';
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default function useCalendarRef(calendarRef, _ref) {
  var navigate = _ref.navigate;
  useImperativeHandle(calendarRef, function () {
    return {
      navigate: navigate
    };
  }, [navigate]);
}